import React from "react";
import {
  Box,
  Typography
} from "@mui/material";

const ClinicalTrialsBenefits = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 3
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{ mb: 3 }}
      >
        What are the Benefits of Clinical Trials?
      </Typography>

      <Box mb={2}>
        <Typography fontWeight="bold" display="inline"  >Innovative Approach:</Typography>
        <Typography variant="body1" display="inline">
          {" Multiple Myeloma presents complex challenges. Massive Bio offers an innovative solution that leverages the latest medical advancements to identify potential treatment options, with a focus on patient well-being."}
        </Typography>
      </Box>

      <Box mb={2}>
        <Typography fontWeight="bold" display="inline"  > Personalized Match: </Typography>
        <Typography variant="body1" display="inline">
          {" Each plan is tailored to the individual’s unique needs—factoring in symptoms, prognosis, and medical history—to ensure the most suitable clinical trial matches."}
        </Typography>
      </Box>

      <Box mb={2}>
        <Typography fontWeight="bold" display="inline"  >
          Personalized Guidance:
        </Typography>
        <Typography variant="body1" display="inline">
          {" Massive Bio’s clinical team provides ongoing support throughout the process, answering questions, offering information, and guiding patients through available options and trials."}
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="body1">
        By enrolling in the matching program, patients gain access to a potentially life-changing approach and take an active role in exploring new treatment possibilities.
        </Typography>
      </Box>
    </Box>
  );
};

export default ClinicalTrialsBenefits;